export { default } from "./BoxError";
